export const EMPLOYEE_HR_DOCUMENTS_FILTER_FORM_DEFAULT_PARAMS = Object.freeze({
  createdAt: undefined,
  updatedAt: undefined,
  numOfDays: undefined,
  datesFromTo: undefined,
});

export const EMPLOYEE_HR_DOCUMENTS_COLUMNS_DEFAULT_PARAMS = Object.freeze({
  status: undefined,
  typeOfLeave: undefined,
  sortTypeOfLeave: undefined,
  sortStatus: undefined,
  sortCreatedAt: undefined,
});

export const EMPLOYEE_HR_DOCUMENTS_FORM_DEFAULT_PARAMS = Object.freeze({
  typeOfLeaveSelect: 'holidayLeave',
});

export const EMPLOYEE_FORM_DEFAULT_PARAMS = Object.freeze({
  route: 'general-data',
});

export const EMPLOYEE_EDIT_DEFAULT_PARAMS = Object.freeze({
  ...EMPLOYEE_HR_DOCUMENTS_FILTER_FORM_DEFAULT_PARAMS,
  ...EMPLOYEE_HR_DOCUMENTS_COLUMNS_DEFAULT_PARAMS,
  ...EMPLOYEE_HR_DOCUMENTS_FORM_DEFAULT_PARAMS,
  ...EMPLOYEE_FORM_DEFAULT_PARAMS,
});

export const EMPLOYEE_COLUMNS_DEFAULT_PARAMS = Object.freeze({
  firstName: undefined,
  lastName: undefined,
  status: undefined,
  employeeSector: undefined,
  'generalData.email': undefined,
  'generalData.city': undefined,
  'generalData.personalNumber': undefined,
});

export const EMPLOYEE_FILTER_FORM_DEFAULT_PARAMS = Object.freeze({
  createdAt: undefined,
  updatedAt: undefined,
  status: undefined,
  'employmentSettings.employmentType': undefined,
  'employmentSettings.startDate': undefined,
  'employmentSettings.endDate': undefined,
  'employmentSettings.workTimeType': undefined,
  'employmentSettings.isHrOfficer': undefined,
  'holidayLeaveCalculation.numberOfHolidayDaysPast': undefined,
  includeNonEmployment: undefined,
  onlyNonEmployment: undefined,
});

export const EMPLOYEE_DEFAULT_PARAMS = Object.freeze({
  offset: '1',
  limit: '10',

  // filters
  company: 'all',
  firstName: undefined,
  lastName: undefined,
  status: undefined,
  createdAt: undefined,
  updatedAt: undefined,
  employeeSector: undefined,
  companies: undefined,
  'generalData.email': undefined,
  'generalData.city': undefined,
  'generalData.personalNumber': undefined,
  'employmentSettings.employmentType': undefined,
  'employmentSettings.startDate': undefined,
  'employmentSettings.endDate': undefined,
  'employmentSettings.workTimeType': undefined,
  'employmentSettings.isHrOfficer': undefined,
  'holidayLeaveCalculation.numberOfHolidayDaysPast': undefined,
  includeNonEmployment: undefined,
  onlyNonEmployment: undefined,

  // sorters
  sortFirstName: undefined,
  sortLastName: undefined,
  sortCompany: undefined,
  sortCity: undefined,
  sortCreatedAt: undefined,
  sortUpdatedAt: undefined,

  ...EMPLOYEE_FORM_DEFAULT_PARAMS,
  ...EMPLOYEE_HR_DOCUMENTS_COLUMNS_DEFAULT_PARAMS,
});
